"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToTop = exports.ScrollToTop = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/up-to-top/24.js"));
var _useWindowSize = require("../../common/Hooks/useWindowSize");
var _useScrollPosition = require("../../common/Hooks/useScrollPosition");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n#scroll-to-top {\n  background: #e8e8e8;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  right: 16px;\n  top: calc(50% - 25px); }\n  #scroll-to-top:hover {\n    cursor: pointer; }\n  @media (max-width: 671px) {\n    #scroll-to-top {\n      display: none; } }\n";
  const fileName = "ScrollToTop_ScrollToTop";
  const element = document.querySelector("style[data-sass-component='ScrollToTop_ScrollToTop']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const scrollToTop = () => {
  window.scrollTo(0, 0);
};
exports.scrollToTop = scrollToTop;
const ScrollToTop = () => {
  const windowSize = (0, _useWindowSize.useWindowSize)();
  const scrollPosition = (0, _useScrollPosition.useScrollPosition)();
  const show = scrollPosition >= 2 * windowSize.height;
  const style = !show ? {
    display: 'none'
  } : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'scroll-to-top',
    onClick: scrollToTop,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_.default, null));
};
exports.ScrollToTop = ScrollToTop;